// extracted by css-extract-rspack-plugin
export default {"adornment":"adornment-qdCvvO","adornmentIsStart":"adornmentIsStart-uXhl52","adornmentIsEnd":"adornmentIsEnd-MZzoVs"};